import React, { memo } from 'react'

import { bool } from 'prop-types'

import AdvancedFiltersContent from 'Pods/SearchPage/Shared/AdvancedFiltersContent/AdvancedFiltersContent'
import DatePublishedContent from 'Pods/SearchPage/Shared/DatePublishedContent/DatePublishedContent'
import DesignerContent from 'Pods/SearchPage/Shared/DesignerContent/DesignerContent'
import LicenseContent from 'Pods/SearchPage/Shared/LicenseContent/LicenseContent'
import PopoverFeaturesContent from 'Pods/SearchPage/Shared/PopoverFeaturesContent/PopoverFeaturesContent'
import QualityContent from 'Pods/SearchPage/Shared/QualityContent/QualityContent'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'

// lg (1280-1599, Figma 3016:128923 / 3016:129654): one scrollable column led by the groups whose own
// row 1 dropdowns are hidden at this width, then General / My library and Designer.
function StackedSections({
  showQualityOverflow = false, showLicenseOverflow = false, showDateOverflow = false, showDesignerSection = false,
}) {
  const translate = useTranslate()

  return (
    <>
      {showQualityOverflow && (
        <>
          <div className="more-filters__overflow-title cgt-overline-md">
            {translate('search_page.filters.quality.title')}
          </div>
          <QualityContent />
          <div className="cgt-divider" aria-hidden="true" />
        </>
      )}
      {showLicenseOverflow && (
        <>
          <div className="more-filters__overflow-title cgt-overline-md">
            {translate('search_page.filters.license.title')}
          </div>
          <LicenseContent hideGroupLabels />
          <div className="cgt-divider" aria-hidden="true" />
        </>
      )}
      {showDateOverflow && (
        <>
          <div className="more-filters__overflow-title cgt-overline-md">
            {translate('search_page.filters.date_published.title')}
          </div>
          <DatePublishedContent />
          <div className="cgt-divider" aria-hidden="true" />
        </>
      )}
      <PopoverFeaturesContent />
      <AdvancedFiltersContent />
      {showDesignerSection && (
        <>
          <div className="cgt-divider" aria-hidden="true" />
          <div className="more-filters__overflow-title cgt-overline-md">
            {translate('search_page.filters.designers.title')}
          </div>
          {/* The popover's footer Reset clears designers, so the section hides its own. */}
          <DesignerContent hideReset />
        </>
      )}
    </>
  )
}

StackedSections.propTypes = {
  showQualityOverflow: bool,
  showLicenseOverflow: bool,
  showDateOverflow: bool,
  showDesignerSection: bool,
}

export default memo(StackedSections)
